import axios from 'axios';
import authHeader from '../../../app/axios/header';
import { IStatistics } from '../types';

export const getStatistics = async (id: string) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}users/${id}/statistics`, { headers: authHeader() })
    .then((response) => {
      return response;
    });
};

export const upsertStatistics = async (id: string, statisticsData: IStatistics) => {
  return axios
    .put(`${process.env.REACT_APP_API_URL}users/${id}/statistics`, statisticsData, {
      headers: authHeader(),
    })
    .then((response) => {
      return response;
    });
};
